export default {
  'pages.applicationCenter.card.free': 'Free',
  'pages.applicationCenter.card.paid': 'Paid',
  'pages.applicationCenter.card.perSeat': 'Per-seat pricing',
  'pages.applicationCenter.card.pricePending': 'Price pending confirmation',
  'pages.applicationCenter.card.developerUnknown': 'Developer not provided',
  'pages.applicationCenter.card.noDescription':
    'No app summary available. View details to learn more.',
  'pages.applicationCenter.card.official': 'Officially verified',
  'pages.applicationCenter.card.installed': 'Activated',
};
